/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./src/forms'));
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/@angular/forms/index.js
 ** module id = 906
 ** module chunks = 0
 **/